import {useUserContext} from "../../context/UserContextProvider";
import {useEffect, useState} from "react";
import {useApolloClient} from "@apollo/client";

const DecideRoute = ({
                         maintenanceContentWrapper, components, MountPointWrapper,
                         PlatformApp, helperFunctions, UnauthorizedWrapper, LoadingWrapper
                     }) => {

    const {userData} = useUserContext();
    const client = useApolloClient();

    useEffect(async () => {
            const userprofile = await helperFunctions.getUser(client);
            if (userData !== null) {
                const isLinked = helperFunctions.isAdvertiserLinked(userprofile.companies, userData.currentCompany);

                if (isLinked) {
                    setRoutes(helperFunctions.getCampaignsRoute(maintenanceContentWrapper,
                        components, helperFunctions.generateRoute))
                } else {

                    setRoutes(helperFunctions.getCampaignsRoute(maintenanceContentWrapper,
                        UnauthorizedWrapper, helperFunctions.generateRoute))
                }
            }
        }, [userData]
    )

    const [routes, setRoutes] = useState(helperFunctions.generateRoute(LoadingWrapper));
    const getPlatformDomains = helperFunctions.getPlatformDomains();

    return <>
        <MountPointWrapper/>
        <PlatformApp routes={routes} platformDomains={getPlatformDomains}/>
    </>

}

export default DecideRoute;